import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "text--text",
      attrs: { id: "section-practice", "data-qa": "section_practice" },
    },
    [
      _c(_setup.PreviewPractice, {
        on: { "click:show-more": _setup.handleClickShowMore },
      }),
      _vm._v(" "),
      _c(
        _setup.CoreBottomSheet,
        {
          attrs: { eager: "", "slot-content-class": "gr-6" },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass:
                            "primary--text text-subtitle-1 rounded-lg",
                          attrs: {
                            block: "",
                            depressed: "",
                            large: "",
                            color: "bg-primary",
                            "data-qa": "section_practice_close",
                          },
                          on: {
                            click: function ($event) {
                              _setup.isVisibleBottomSheet = false
                            },
                          },
                        },
                        [_vm._v("\n          Закрыть\n        ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.isVisibleBottomSheet,
            callback: function ($$v) {
              _setup.isVisibleBottomSheet = $$v
            },
            expression: "isVisibleBottomSheet",
          },
        },
        [
          _c(_setup.IntroductionContent, {
            staticClass: "mb-2",
            attrs: { variant: "drawer" },
          }),
          _vm._v(" "),
          _c(_setup.DiseasesStatistics, { staticClass: "mb-2" }),
          _vm._v(" "),
          _c(_setup.PatientStatistics, { staticClass: "mb-2" }),
          _vm._v(" "),
          _c(_setup.LpuListPartners, { staticClass: "mb-2" }),
          _vm._v(" "),
          _c(_setup.PracticeUpdatedDate),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }